import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
const BASE_URL = baseUrl +'/device' 
export default {
	/**
	 * 灯组列表接口
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	lampGroupList( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: BASE_URL + '/lampGroup',
	    method: 'GET',
	    params
	  })
	},
	/**
	 * 灯组添加接口
	**/
    lampGroupAdd(data) {
		return request({
	    url: BASE_URL + '/lampGroup',
	    method: 'POST',
	    data
	  })
	},
	/**
	 * 灯组编辑接口
	**/
	lampGroupEdit(id,data){
		return request({
			url: BASE_URL + '/lampGroup/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 删除灯组接口
	**/
	lampGroupDel(id){
		return request({
			url: BASE_URL + '/lampGroup/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 路灯分配-分配或者取消路灯
	 * @param {type} 0未分配1已分配
	 * @param {lamp_ids} 1,2,3 所选设备
	 * @param {group} 路灯ID
	**/
	groupFen(data){
		return request({
			url: BASE_URL + '/GroupFen',
			method:'POST',
			data
		})
	},

	/**
	 * 路灯分配
	 * @param {group} 路灯ID
	**/
	getLampList( params={} ) {
		return request({
	    url: BASE_URL + '/getLampGroup',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 灯组控制 
	 * @param {id} 灯组ID
	 * @param {data:{light}} 亮度
	**/
	groupControl(id,data){
		return request({
			url: BASE_URL + '/lampGroupControl/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 没有分组的路灯
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	getUnassignedGroupLamps( params={} ) {
		return request({
	    url: BASE_URL + '/getUnassignedGroupLamps',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 绑定/解绑路灯分组
	 * @param {allocation} 0取消，1绑定
	 * @param {lamp_group} 分组ID
	 * @param {ids} 路灯ID
	**/
    bindGroup(data) {
		return request({
	    url: baseUrl + '/device/bindGroup',
	    method: 'POST',
	    data
	  })
	}
}